import React from "react";

/** Year heading above a photo grid's year group (see `groupByYear` in Helpers/photoOrdering). */
const PhotoYearHeading: React.FC<{ year: string }> = ({ year }) => (
    <div style={{fontSize: '0.85rem', fontWeight: 600, color: '#6c757d', marginBottom: '6px'}}>
        {year}
    </div>
);

export default PhotoYearHeading;
